export default "/card_sample.fcd5ecb6-4f58ad.png";